import { connect } from 'react-redux';
import { addOptions, clearOptions, fetchProductBasicInfo } from 'apps/products/actions/productDetails';

import Derivatives from '../components/partials/Derivatives';

export default connect(
  (state, ownProps) => ({
    ...ownProps,
    options: state.products.productDetailsBySku[ownProps.sku].options,
    productWarnings: state.basket.productWarnings,
  }), {
    addOptions,
    fetchProductBasicInfo,
    clearOptions,
  },
)(Derivatives);
